module.exports = __webpack_public_path__ + "img/pin-1000.faae44ff.png";